import Vue from 'vue';

class LanguageHandler {
    constructor(config) {
        this.config = config;
    }

    getAvailableLanguages() {
        return this.config.languages || [];
    }

    setUsedLanguages(languages) {
        this.usedLanguages = languages;
    }

    getLanguageStringsWithTheirUuids(sourceLanguage, targetLanguage) {
        const allElements = this.getAllElements();
        const hotpotElements = this.getHotspotElements();
        console.log('hotpotElements:', hotpotElements);
        allElements.push(...hotpotElements);
        const languageStrings = {};
        allElements.forEach(element => {
            const {loginButton, fields = []} = element;
            if (loginButton) {
                element = loginButton;
            }
            for (let i = 0; i < fields.length; i++) {
                const field = fields[i];
                if (field.label && field.label.dix && field.label.dix[sourceLanguage] && field.label.dix[sourceLanguage] !== '') {
                    languageStrings[field.uuid] = {
                        original: field.label.dix[sourceLanguage] ? field.label.dix[sourceLanguage] : '',
                        translated: field.label.dix[targetLanguage] ? field.label.dix[targetLanguage] : '',
                    };
                }
            }
            if (element.label && element.label.dix && element.label.dix[sourceLanguage] && element.label.dix[sourceLanguage] !== '') {
                languageStrings[element.uuid] = {
                    original: element.label.dix[sourceLanguage] ? element.label.dix[sourceLanguage] : '',
                    translated: element.label.dix[targetLanguage] ? element.label.dix[targetLanguage] : '',
                };
            }
            if (element.options) {
                element.options.forEach(option => {
                    if (option.text && option.text.dix && option.text.dix[sourceLanguage] && option.text.dix[sourceLanguage] !== '') {
                        languageStrings[option.uuid] = {
                            original: option.text.dix[sourceLanguage] ? option.text.dix[sourceLanguage] : '',
                            translated: option.text.dix[targetLanguage] ? option.text.dix[targetLanguage] : '',
                        };
                    }
                });
            }
        });
        if(this.config.slidesMeta) {
            this.config.slidesMeta.forEach(slide => {
                slide.hotspots.forEach(hotspot => {
                    if(hotspot.label && hotspot.label.dix && hotspot.label.dix[sourceLanguage] && hotspot.label.dix[sourceLanguage] !== '') {
                        languageStrings[hotspot.uuid] = {
                            original: hotspot.label.dix[sourceLanguage] ? hotspot.label.dix[sourceLanguage] : '',
                            translated: hotspot.label.dix[targetLanguage] ? hotspot.label.dix[targetLanguage] : '',
                        };
                    }
                });
            });
        }

        return languageStrings;
    }
    getHotspotElements() {
        const hotspotElements = [];
        const {slidesMeta} = this.config;
        if (slidesMeta) {
            slidesMeta.forEach(slide => {
                slide.hotspots.forEach(hotspot => {
                    if (hotspot.elements) {
                        hotspotElements.push(...hotspot.elements);
                    }
                })
            })
        }
        return hotspotElements;
    }

    getAllElements() {
        const allElements = [];
        const {steps, global} = this.config;
        if (steps) {
            steps.forEach(step => {
                if (step.elements) {
                    allElements.push(...step.elements);
                }
            });
        }
        if (global && global.elements) {
            allElements.push(...global.elements);
        }
        return allElements;
    }

    getTranslatedLanguageKeys() {
        const allElements = this.getAllElements();
        let languages = new Set();
        allElements.forEach(element => {
            if (element.label) {
                Object.keys(element.label.dix).forEach(langKey => {
                    languages.add(langKey);
                });
            }
            if (element.options) {
                element.options.forEach(option => {
                    if (option.text) {
                        Object.keys(option.text.dix).forEach(langKey => {
                            languages.add(langKey);
                        });
                    }
                });
            }
        });
        this.usedLanguages = Array.from(languages);
        return this.usedLanguages;
    }

    dealWithMultilineText(text) {
        if (typeof text === 'string') {
            return text
                .replace(/\\n/g, '\n')    // real newlines
                .replace(/\\"/g, '"');    // proper quotes
        }
        return text;
    }

    translateElementAndOptions(element, targetLanguage, translationStrings) {
        const {loginButton, fields = []} = element;
        // loginButton has also a label, fields are an array and can have labels too
        if (element.label && element.label.dix) {
            const translatedString = translationStrings[element.uuid] ? this.dealWithMultilineText(translationStrings[element.uuid].translated) : element.label.dix[targetLanguage];
            console.log('Translating element', element.uuid, translatedString);
            console.log('found translationStrings:', translationStrings[element.uuid]);
            element.label.dix[targetLanguage] = translatedString;
        }
        if (loginButton && loginButton.label && loginButton.label.dix) {
            const translatedString = translationStrings[loginButton.uuid] ? this.dealWithMultilineText(translationStrings[loginButton.uuid].translated) : loginButton.label.dix[targetLanguage];
            element.loginButton.label.dix[targetLanguage] = translatedString;
        }
        for (let i = 0; i < fields.length; i++) {
            const {uuid: fieldUuid} = fields[i];
            const translatedString = translationStrings[fieldUuid];
            if (translatedString) {
                element.fields[i].label.dix[targetLanguage] = this.dealWithMultilineText(translatedString.translated);
            }
        }
        if (element.options) {
            for (let k = 0; k < element.options.length; k++) {
                let option = element.options[k];
                if (translationStrings[option.uuid]) {
                    const translatedString = translationStrings[option.uuid] ? this.dealWithMultilineText(translationStrings[option.uuid].translated) : option.text.dix[targetLanguage];
                    option.text.dix[targetLanguage] = translatedString;
                    element.options[k] = option;
                }
            }
        }
        return element;
    }

    importLanguageStrings(targetLanguage, translatedStrings) {
        console.log('Importing language strings for language', targetLanguage, translatedStrings);
        const {steps, global, slidesMeta} = this.config;
        if (steps) {
            for (let i = 0; i < steps.length; i++) {
                const step = this.config.steps[i];
                for (let j = 0; j < step.elements.length; j++) {
                    let element = step.elements[j];
                    const resultingElement = this.translateElementAndOptions(element, targetLanguage, translatedStrings);
                    Vue.set(step.elements, j, resultingElement);
                }
            }
        }
        if (global && global.elements) {
            for (let m = 0; m < global.elements.length; m++) {
                let element = this.config.global.elements[m];
                element = this.translateElementAndOptions(element, targetLanguage, translatedStrings);
                Vue.set(this.config.global.elements, m, element);
            }
        }
        if (slidesMeta && slidesMeta.length) {
            for (let s = 0; s < slidesMeta.length; s++) {
                const slide = slidesMeta[s];
                for (let h = 0; h < slide.hotspots.length; h++) {
                    const hotspot = slide.hotspots[h];
                    for (let e = 0; e < hotspot.elements.length; e++) {
                        let element = hotspot.elements[e];
                        element = this.translateElementAndOptions(element, targetLanguage, translatedStrings);
                        Vue.set(hotspot.elements, e, element);
                    }
                    if(hotspot.label) {
                        const translatedString = translatedStrings[hotspot.uuid] ? this.dealWithMultilineText(translatedStrings[hotspot.uuid].translated) : hotspot.label.dix[targetLanguage];
                        hotspot.label.dix[targetLanguage] = translatedString;
                    }
                }
            }
        }
    }
}

export default LanguageHandler;